import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { SeparacaoList } from '@/features/separacao/page/list/SeparacaoList';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/separacao/')({
    beforeLoad: () => {
        validateRoute({
            fintech: false,
            validatePermission: (permissions) => {
                return (
                    isPermissionParcialOrFull(permissions.upp_logistica) ||
                    isPermissionParcialOrFull(permissions.upp_logistica_conferencia) ||
                    isPermissionParcialOrFull(permissions.upp_logistica_separacao)
                );
            },
        });
    },
    component: SeparacaoList,
});
